(function () {
  'use strict';

  var FILTER_ATTR = {
    badge: 'data-tt-badges',
    colour: 'data-tt-colour',
    room: 'data-tt-rooms',
    technique: 'data-tt-look-material',
    motif: 'data-tt-look-pattern',
    finish: 'data-tt-finish',
    shape: 'data-tt-shape',
    size: 'data-tt-size',
    style: 'data-tt-style',
    surface: 'data-tt-surface'
  };

  var MULTI_URL_KEYS = {
    room: true,
    style: true,
    surface: true
  };

  var DEFAULT_CATEGORY_PAGES = [
    { param: 'style', value: 'Victorian', heading: 'Victorian Tiles', pattern: 'victorian', description: 'Heritage and vintage patterned tiles for hallways, kitchens and bathrooms.' },
    { param: 'style', value: 'Mediterranean', heading: 'Mediterranean Tiles', pattern: 'mediterranean', description: 'Warm colour, patchwork and sun-washed pattern for kitchens and outdoor rooms.' },
    { param: 'style', value: 'Art Deco', heading: 'Art Deco Tiles', pattern: 'geometric', description: 'Bold geometry and high-contrast colour with 1920s character.' },
    { param: 'style', value: 'Scandinavian', heading: 'Scandinavian Tiles', pattern: 'natural', description: 'Quiet colour and natural texture for calm bathrooms, kitchens and living spaces. Also known as Japandi.' },
    { param: 'style', value: 'Rustic', heading: 'Rustic Tiles', pattern: 'rustic', description: 'Stone, wood and terracotta character for country kitchens and cosy hallways.' },
    { param: 'technique', value: 'Zellige', heading: 'Zellige Tiles', pattern: 'zellige', description: 'Hand-finished colour and a softly irregular glaze for splashbacks and feature walls.' },
    { param: 'technique', value: 'Terrazzo', heading: 'Terrazzo Tiles', pattern: 'terrazzo', description: 'Speckled terrazzo surfaces for floors, kitchens and contemporary bathrooms.' },
    { param: 'technique', value: 'Wood', heading: 'Wood Tiles', pattern: 'wood', description: 'Wood-effect tiles with the warmth of timber and the durability of porcelain.' },
    { param: 'technique', value: 'Marble', heading: 'Marble Tiles', pattern: 'marble', description: 'Marble-effect tiles for bathrooms, kitchens and living spaces.' },
    { param: 'motif', value: 'Geometric', heading: 'Geometric Tiles', pattern: 'geometric', description: 'Graphic repeats and contemporary pattern for floors, splashbacks and feature walls.' },
    { param: 'motif', value: 'Floral', heading: 'Floral Tiles', pattern: 'patterned', description: 'Botanical repeats and painted blooms for floors and feature walls.' },
    { param: 'motif', value: 'Checkerboard', heading: 'Checkerboard Tiles', pattern: 'checkerboard', description: 'Classic two-tone grids for hallways, kitchens and bathrooms.' },
    { param: 'shape', value: 'Hexagonal', heading: 'Hexagonal Tiles', pattern: 'hexagonal', description: 'Hexagon tiles for a striking geometric finish on floors and feature walls.' },
    { param: 'shape', value: 'Metro', heading: 'Metro Tiles', pattern: 'wall', description: 'Metro tiles for splashbacks and bathroom walls. A long, linear look, also searched as plank.' },
    { param: 'finish', value: 'Sculptural', heading: 'Sculptural Tiles', pattern: 'sculptural', description: 'Relief and three-dimensional texture that catches the light on feature walls.' }
  ];

  var LEGACY_LOOK_PATTERN = {
    Encaustic: { key: 'technique', value: 'Encaustic' },
    'Moroccan & Encaustic': { key: 'technique', value: 'Encaustic' },
    Moroccan: { key: 'technique', value: 'Encaustic' },
    Zellige: { key: 'technique', value: 'Zellige' },
    Terrazzo: { key: 'technique', value: 'Terrazzo' },
    Geometric: { key: 'motif', value: 'Geometric' },
    'Geometric & Contemporary': { key: 'motif', value: 'Geometric' },
    Star: { key: 'motif', value: 'Geometric' },
    Striped: { key: 'motif', value: 'Geometric' },
    Floral: { key: 'motif', value: 'Floral' },
    Checkerboard: { key: 'motif', value: 'Checkerboard' },
    Gradient: { key: 'motif', value: 'Gradient' },
    Victorian: { key: 'style', value: 'Victorian' },
    'Victorian & Edwardian': { key: 'style', value: 'Victorian' },
    Mediterranean: { key: 'style', value: 'Mediterranean' },
    'Patchwork & Eclectic': { key: 'style', value: 'Mediterranean' },
    Patchwork: { key: 'style', value: 'Mediterranean' },
    Eclectic: { key: 'style', value: 'Mediterranean' },
    Hexagonal: { key: 'shape', value: 'Hexagonal' },
    Hexagon: { key: 'shape', value: 'Hexagonal' },
    Herringbone: { key: 'shape', value: 'Herringbone' },
    'Herringbone & Chevron': { key: 'shape', value: 'Herringbone' }
  };

  function canonicalizeTechnique(value) {
    if (value === 'Stone' || value === 'Natural stone') return 'Natural Stone';
    if (value === 'Terrazoo') return 'Terrazzo';
    return value;
  }

  function canonicalizeMotif(value) {
    var mapped = LEGACY_LOOK_PATTERN[value];
    return mapped && mapped.key === 'motif' ? mapped.value : value;
  }

  function canonicalizeShape(value) {
    if (value === 'Hexagon') return 'Hexagonal';
    if (/kit[\s-]?kat/i.test(value || '')) return 'Kit-Kat';
    if (value === 'Plank' || value === 'Metro / Subway' || value === 'Subway') return 'Metro';
    return value;
  }

  function canonicalizeFinish(value) {
    if (value === 'Matt') return 'Matte';
    return value;
  }

  function canonicalizeStyle(value) {
    if (value === 'Japandi') return 'Scandinavian';
    if (value === 'Vintage' || value === 'Heritage') return 'Victorian';
    var mapped = LEGACY_LOOK_PATTERN[value];
    return mapped && mapped.key === 'style' ? mapped.value : value;
  }

  function pushUnique(list, value) {
    if (!value || list.indexOf(value) !== -1) return;
    list.push(value);
  }

  function cardTaxonomy(card) {
    var technique = splitPipe(card.getAttribute('data-tt-look-material') || '');
    var motif = splitPipe(card.getAttribute('data-tt-look-pattern') || '');
    var style = splitPipe(card.getAttribute('data-tt-style') || '');
    var shape = card.getAttribute('data-tt-shape') || '';
    var finish = card.getAttribute('data-tt-finish') || '';
    var texture = splitPipe(card.getAttribute('data-tt-look-texture') || '');
    var nextTechnique = [];
    var nextMotif = [];
    var nextStyle = style.slice();

    technique.forEach(function (raw) {
      pushUnique(nextTechnique, canonicalizeTechnique(raw));
    });

    motif.forEach(function (raw) {
      var mapped = LEGACY_LOOK_PATTERN[raw];
      if (mapped) {
        if (mapped.key === 'technique') pushUnique(nextTechnique, mapped.value);
        else if (mapped.key === 'motif') pushUnique(nextMotif, mapped.value);
        else if (mapped.key === 'style') pushUnique(nextStyle, mapped.value);
        else if (mapped.key === 'shape' && !shape) shape = mapped.value;
        return;
      }
      pushUnique(nextMotif, canonicalizeMotif(raw));
    });

    if (texture.some(function (value) { return /kit[\s-]?kat/i.test(value); })) {
      shape = 'Kit-Kat';
    }

    return {
      technique: nextTechnique,
      motif: nextMotif,
      style: nextStyle.map(canonicalizeStyle).filter(Boolean),
      shape: canonicalizeShape(shape),
      finish: canonicalizeFinish(finish)
    };
  }

  function splitPipe(value) {
    if (!value) return [];
    return value.split('|').filter(Boolean);
  }

  function getCheckedFilters(root) {
    var groups = {};
    root.querySelectorAll('[data-tt-filter]:checked').forEach(function (input) {
      var key = input.getAttribute('data-tt-filter');
      if (!groups[key]) groups[key] = [];
      groups[key].push(input.value);
    });
    return groups;
  }

  function productMatches(card, groups) {
    var keys = Object.keys(groups);
    var tax = cardTaxonomy(card);
    for (var i = 0; i < keys.length; i++) {
      var key = keys[i];
      var selected = groups[key];
      if (!selected.length) continue;

      if (key === 'badge') {
        var badgeHit = selected.some(function (sel) {
          if (sel === 'On Sale') {
            return card.getAttribute('data-tt-on-sale') === 'true';
          }
          if (sel === 'Out of Stock') {
            return card.getAttribute('data-tt-out-of-stock') === 'true'
              || splitPipe(card.getAttribute('data-tt-badges') || '').indexOf(sel) !== -1;
          }
          return splitPipe(card.getAttribute('data-tt-badges') || '').indexOf(sel) !== -1;
        });
        if (!badgeHit) return false;
        continue;
      }

      if (key === 'technique') {
        if (!selected.some(function (sel) {
          return tax.technique.indexOf(canonicalizeTechnique(sel)) !== -1;
        })) return false;
        continue;
      }

      if (key === 'motif') {
        if (!selected.some(function (sel) {
          return tax.motif.indexOf(canonicalizeMotif(sel)) !== -1;
        })) return false;
        continue;
      }

      if (key === 'finish') {
        if (!selected.some(function (sel) {
          return tax.finish === canonicalizeFinish(sel);
        })) return false;
        continue;
      }

      if (key === 'shape') {
        if (!selected.some(function (sel) {
          return tax.shape === canonicalizeShape(sel);
        })) return false;
        continue;
      }

      if (key === 'style') {
        if (!selected.some(function (sel) {
          return tax.style.indexOf(canonicalizeStyle(sel)) !== -1;
        })) return false;
        continue;
      }

      var attr = FILTER_ATTR[key];
      if (!attr) continue;

      var raw = card.getAttribute(attr) || '';
      var values = key === 'colour'
        ? (raw ? [raw] : [])
        : splitPipe(raw);

      var hit = selected.some(function (sel) {
        return values.indexOf(sel) !== -1;
      });

      if (!hit) return false;
    }
    return true;
  }

  function decodeParam(value) {
    if (!value) return '';
    try {
      return decodeURIComponent(value.replace(/\+/g, ' '));
    } catch (e) {
      return value;
    }
  }

  function clearFilterInputs(root) {
    root.querySelectorAll('[data-tt-filter]').forEach(function (input) {
      input.checked = false;
    });
  }

  var SERVER_FILTER_DATASET = {
    badge: 'ttInitialBadge',
    colour: 'ttInitialColour',
    room: 'ttInitialRoom',
    technique: 'ttInitialTechnique',
    motif: 'ttInitialMotif',
    finish: 'ttInitialFinish',
    shape: 'ttInitialShape',
    size: 'ttInitialSize',
    style: 'ttInitialStyle',
    surface: 'ttInitialSurface'
  };

  function setFilterChecks(root, key, value) {
    if (!value) return;

    var values = MULTI_URL_KEYS[key] ? splitPipe(value.replace(/,/g, '|')) : [value];
    if (key === 'technique') values = values.map(canonicalizeTechnique);
    if (key === 'motif') values = values.map(canonicalizeMotif);
    if (key === 'shape') values = values.map(canonicalizeShape);
    if (key === 'finish') values = values.map(canonicalizeFinish);
    if (key === 'style') values = values.map(canonicalizeStyle);

    root.querySelectorAll('[data-tt-filter="' + key + '"]').forEach(function (input) {
      input.checked = values.indexOf(input.value) !== -1;
    });
  }

  function filterGroupIsActive(root, key) {
    return !!root.querySelector('[data-tt-filter="' + key + '"]:checked');
  }

  function remapLegacySearchParams(params) {
    var out = {};

    function set(key, value) {
      if (!value || out[key]) return;
      out[key] = value;
    }

    Object.keys(FILTER_ATTR).forEach(function (key) {
      var value = decodeParam(params.get(key));
      if (!value) return;
      if (key === 'technique') value = canonicalizeTechnique(value);
      if (key === 'motif') value = canonicalizeMotif(value);
      if (key === 'shape') value = canonicalizeShape(value);
      if (key === 'finish') value = canonicalizeFinish(value);
      if (key === 'style') value = canonicalizeStyle(value);
      out[key] = value;
    });

    var lookMaterial = decodeParam(params.get('look_material'));
    if (lookMaterial) set('technique', canonicalizeTechnique(lookMaterial));

    var lookPattern = decodeParam(params.get('look_pattern'));
    if (lookPattern) {
      var mapped = LEGACY_LOOK_PATTERN[lookPattern];
      if (mapped) set(mapped.key, mapped.value);
      else set('motif', lookPattern);
    }

    var lookTexture = decodeParam(params.get('look_texture'));
    if (lookTexture && /kit[\s-]?kat/i.test(lookTexture)) set('shape', 'Kit-Kat');

    return out;
  }

  function syncFiltersFromUrl(root) {
    if (!window.URLSearchParams) return;

    clearFilterInputs(root);

    var params = new URLSearchParams(window.location.search);
    var remapped = remapLegacySearchParams(params);
    Object.keys(remapped).forEach(function (key) {
      setFilterChecks(root, key, remapped[key]);
    });
  }

  function urlHasBrowseFilters() {
    if (!window.URLSearchParams) return false;
    var params = new URLSearchParams(window.location.search);
    if (Object.keys(FILTER_ATTR).some(function (key) { return !!params.get(key); })) return true;
    return !!(params.get('look_material') || params.get('look_pattern') || params.get('look_texture'));
  }

  function canonicalizeFilterValue(key, value) {
    if (key === 'technique') return canonicalizeTechnique(value);
    if (key === 'motif') return canonicalizeMotif(value);
    if (key === 'shape') return canonicalizeShape(value);
    if (key === 'finish') return canonicalizeFinish(value);
    if (key === 'style') return canonicalizeStyle(value);
    return value;
  }

  /** Filters the visitor asked for via URL or collection handle. Do not drop these. */
  function requestedFilters(root) {
    var requested = {};

    function add(key, raw) {
      if (!raw) return;
      var values = MULTI_URL_KEYS[key] ? splitPipe(String(raw).replace(/,/g, '|')) : [raw];
      values.forEach(function (value) {
        value = canonicalizeFilterValue(key, value);
        if (!value) return;
        if (!requested[key]) requested[key] = [];
        if (requested[key].indexOf(value) === -1) requested[key].push(value);
      });
    }

    if (window.URLSearchParams) {
      var remapped = remapLegacySearchParams(new URLSearchParams(window.location.search));
      Object.keys(remapped).forEach(function (key) {
        add(key, remapped[key]);
      });
    }

    Object.keys(SERVER_FILTER_DATASET).forEach(function (key) {
      add(key, root.dataset[SERVER_FILTER_DATASET[key]]);
    });

    return requested;
  }

  function isRequestedFilter(requested, key, value) {
    return !!(requested[key] && requested[key].indexOf(value) !== -1);
  }

  function syncFiltersFromServerState(root) {
    if (urlHasBrowseFilters()) return;

    var entryHandle = root.getAttribute('data-entry-handle') || '';
    var hasQuery = !!(window.location.search && window.location.search.length > 1);
    if ((entryHandle === 'all' || entryHandle === '') && !hasQuery) return;

    Object.keys(SERVER_FILTER_DATASET).forEach(function (key) {
      if (filterGroupIsActive(root, key)) return;

      var value = root.dataset[SERVER_FILTER_DATASET[key]];
      if (!value) return;

      setFilterChecks(root, key, value);
    });
  }

  var HEADING_FILTER_ORDER = [
    'badge',
    'colour',
    'room',
    'technique',
    'motif',
    'finish',
    'shape',
    'size',
    'style',
    'surface'
  ];

  function syncUrlFromFilters(root, groups) {
    if (!window.history || !window.URLSearchParams) return;

    var params = new URLSearchParams();
    HEADING_FILTER_ORDER.forEach(function (key) {
      var selected = groups[key];
      if (!selected || !selected.length) return;

      if (MULTI_URL_KEYS[key]) {
        params.set(key, selected.join('|'));
      } else if (selected.length === 1) {
        params.set(key, selected[0]);
      }
    });

    var family = (root.getAttribute('data-tt-family') || '').trim();
    if (!family && window.URLSearchParams) {
      family = (new URLSearchParams(window.location.search).get('family') || '').trim();
    }
    if (family) params.set('family', family);
    if (root.getAttribute('data-tt-browse') === '1') params.set('browse', '1');
    var landingParam = root.getAttribute('data-tt-landing-param');
    var landingValue = root.getAttribute('data-tt-landing-value');
    if (landingParam && landingValue && !params.get(landingParam)) {
      params.set(landingParam, landingValue);
    }

    var query = params.toString();
    var nextUrl = window.location.pathname + (query ? '?' + query : '');
    if (nextUrl !== window.location.pathname + window.location.search) {
      window.history.replaceState({}, '', nextUrl);
    }
  }

  var categorySeoData = null;

  function loadCategorySeoData() {
    if (categorySeoData) return categorySeoData;
    var el = document.getElementById('tt-category-seo-data');
    if (!el) return null;
    try {
      categorySeoData = JSON.parse(el.textContent);
    } catch (e) {
      categorySeoData = null;
    }
    return categorySeoData;
  }

  function getPrimarySeoFilter(groups) {
    for (var i = 0; i < HEADING_FILTER_ORDER.length; i++) {
      var key = HEADING_FILTER_ORDER[i];
      if (key === 'size') continue;
      var selected = groups[key];
      if (selected && selected.length) {
        return { key: key, value: selected[0] };
      }
    }
    return null;
  }

  function getCategorySeoHtml(groups) {
    var primary = getPrimarySeoFilter(groups);
    if (!primary) return '';

    var data = loadCategorySeoData();
    if (!data || !data[primary.key]) return '';

    return data[primary.key][primary.value] || '';
  }

  function shouldShowSeoIntro(groups) {
    return !!getPrimarySeoFilter(groups);
  }

  function updateCollectionDesc(root, showSeo) {
    var desc = root.querySelector('[data-tt-collection-desc]');
    if (desc) desc.hidden = showSeo;
  }

  function getPageHeading(root, groups) {
    for (var i = 0; i < HEADING_FILTER_ORDER.length; i++) {
      var key = HEADING_FILTER_ORDER[i];
      var selected = groups[key];
      if (selected && selected.length) {
        if (key === 'badge' && selected[0] === 'New in') {
          return 'New Tiles';
        }
        return selected[0] + ' Tiles';
      }
    }
    return root.dataset.ttDefaultHeading || 'All Tiles';
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function safeImageUrl(value) {
    var url = String(value || '').trim();
    if (!url) return '';
    if (/^https?:\/\//i.test(url) || url.indexOf('//') === 0) return url;
    return '';
  }

  function loadCategoryPageItems(root) {
    var el = root.querySelector('[data-tt-category-pages]');
    var items = DEFAULT_CATEGORY_PAGES.slice();
    if (!el || !el.textContent) return items;
    try {
      var parsed = JSON.parse(el.textContent);
      var saved = parsed && parsed.items ? parsed.items : [];
      saved.forEach(function (item) {
        if (!item || !item.param || !item.value) return;
        var index = items.findIndex(function (entry) {
          return entry.param === item.param && entry.value === item.value;
        });
        var next = {
          param: item.param,
          value: item.value,
          heading: item.heading || (index >= 0 ? items[index].heading : item.value + ' Tiles'),
          description: item.description || (index >= 0 ? items[index].description : ''),
          image: item.image || '',
          imageAlign: item.imageAlign || item.image_align || 'center',
          pattern: item.pattern || (index >= 0 ? items[index].pattern : 'patterned'),
          products: Array.isArray(item.products) ? item.products : []
        };
        if (index >= 0) items[index] = next;
        else items.push(next);
      });
    } catch (e) { /* keep defaults */ }
    return items;
  }

  function isBrowseView(root) {
    if (root && root.getAttribute('data-tt-browse') === '1') return true;
    if (!window.URLSearchParams) return false;
    var browse = new URLSearchParams(window.location.search).get('browse');
    return browse === '1' || browse === 'true' || browse === 'all';
  }

  function currentCategoryLanding(root, groups) {
    if (isBrowseView(root)) return null;
    if (window.URLSearchParams && new URLSearchParams(window.location.search).get('family')) return null;
    var requested = requestedFilters(root);
    var source = groups || {};
    var items = loadCategoryPageItems(root);
    var matched = null;
    var extra = false;
    HEADING_FILTER_ORDER.forEach(function (key) {
      var selected = source[key] && source[key].length ? source[key] : (requested[key] || []);
      if (!selected.length) return;
      var hit = null;
      if (selected.length === 1) {
        for (var j = 0; j < items.length; j++) {
          if (items[j].param === key && items[j].value === selected[0]) {
            hit = items[j];
            break;
          }
        }
      }
      if (hit && !matched) matched = hit;
      else if (selected.length) extra = true;
    });
    return extra ? null : matched;
  }

  function loadFamilyPages(root) {
    var el = root.querySelector('[data-tt-family-pages]');
    if (!el || !el.textContent) return [];
    try {
      var parsed = JSON.parse(el.textContent);
      return parsed && parsed.items ? parsed.items : [];
    } catch (e) {
      return [];
    }
  }

  function currentFamilyLanding(root) {
    if (isBrowseView(root)) return null;
    var key = (root.getAttribute('data-tt-family') || '').toLowerCase();
    if (!key && window.URLSearchParams) {
      key = (new URLSearchParams(window.location.search).get('family') || '').toLowerCase();
    }
    if (!key) return null;
    var items = loadFamilyPages(root);
    for (var i = 0; i < items.length; i++) {
      if (String(items[i].rangeKey || '').toLowerCase() === key && items[i].enabled !== false) return items[i];
    }
    return { rangeKey: key, title: key, heading: '', description: '', image: '', products: [] };
  }

  function landingDisplayName(item) {
    var heading = item.heading || item.title || item.value || '';
    return String(heading).replace(/\s*tiles\s*$/i, '').replace(/\s*collection\s*$/i, '').trim() || item.value || item.rangeKey || 'these';
  }

  function browseAllHref(param, value) {
    return '/collections/all?' + encodeURIComponent(param) + '=' + encodeURIComponent(value) + '&browse=1';
  }

  var ARROW_SVG = '<span class="tt-arrow"><svg viewBox="0 0 1025 888" xmlns="http://www.w3.org/2000/svg" fill="none" aria-hidden="true" focusable="false"><g transform="translate(-1471 -682)"><path d="M1574 1126 2393 1126M2393 1126 2051.75 785M2393 1126 2051.75 1467" stroke="currentColor" stroke-width="206.25" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" fill="none"></path></g></svg></span>';

  function renderBrowseCta(name, href) {
    return (
      '<div class="tt-landing-cta tt-landing-cta--rail" data-tt-landing-cta data-tt-head>' +
        '<div class="tt-head__rail">' +
          '<span class="tt-head__eyebrow">Search and filter the full range</span>' +
          '<span class="tt-head__rule" aria-hidden="true"></span>' +
        '</div>' +
        '<a class="tt-btn tt-btn--secondary tt-section__link tt-landing-cta__link" href="' + escapeHtml(href) + '">Browse all ' + escapeHtml(name) + ' tiles' + ARROW_SVG + '</a>' +
      '</div>'
    );
  }

  function landingEyebrow(param) {
    switch (param) {
      case 'family': return 'Tile family';
      case 'style': return 'Shop by style';
      case 'technique': return 'Shop by technique';
      case 'motif': return 'Shop by pattern';
      case 'shape': return 'Shop by shape';
      case 'finish': return 'Shop by finish';
      default: return 'Collection';
    }
  }

  // Colour the last word of a heading teal, matching the homepage titles.
  function accentHeading(heading) {
    var words = String(heading || '').trim().split(/\s+/);
    if (words.length < 2) return escapeHtml(heading);
    var last = words.pop();
    return escapeHtml(words.join(' ')) + ' <em>' + escapeHtml(last) + '</em>';
  }

  function refreshHeads() {
    try {
      document.dispatchEvent(new CustomEvent('tt:heads:refresh'));
    } catch (e) { /* old browsers: dividers simply show without drawing */ }
  }

  function syncLandingCtas(root, name, href) {
    root.querySelectorAll('[data-tt-landing-cta]').forEach(function (el) { el.remove(); });
    if (!name || !href) return;
    var host = root.querySelector('.tt-collection__main') || root.querySelector('[data-tt-product-grid]');
    if (host) host.insertAdjacentHTML('afterend', renderBrowseCta(name, href));
  }

  function overviewFact(label, key) {
    return (
      '<div class="tt-overview__fact">' +
        '<span class="tt-overview__fact-label">' + label + '</span>' +
        '<span class="tt-overview__fact-value" data-tt-fact="' + key + '">—</span>' +
      '</div>'
    );
  }

  function cleanFactValue(value) {
    var text = String(value || '').trim();
    if (!text || text === '[]' || text === '{}' || /^null$/i.test(text) || /^undefined$/i.test(text)) return '';
    return text;
  }

  function mostCommon(values) {
    var counts = {};
    var best = '';
    var bestN = 0;
    values.forEach(function (value) {
      if (!value) return;
      counts[value] = (counts[value] || 0) + 1;
      if (counts[value] > bestN) {
        best = value;
        bestN = counts[value];
      }
    });
    return best;
  }

  function overviewCards(root, item) {
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-tt-product]'));
    if (!item) return [];
    if (item.param === 'family') {
      var key = String(item.value || item.rangeKey || '').toLowerCase();
      return cards.filter(function (card) {
        return (card.getAttribute('data-tt-range') || '').toLowerCase() === key;
      });
    }
    if (!item.param || !item.value) return cards;
    var groups = {};
    groups[item.param] = [item.value];
    return cards.filter(function (card) {
      return productMatches(card, groups);
    });
  }

  function landingFacts(root, item) {
    var cards = overviewCards(root, item);
    var styles = [];
    var sizes = [];
    var wall = false;
    var floor = false;
    cards.forEach(function (card) {
      cardTaxonomy(card).style.forEach(function (style) {
        var clean = cleanFactValue(style);
        if (clean) styles.push(clean);
      });
      splitPipe(card.getAttribute('data-tt-size') || '').forEach(function (size) {
        var clean = cleanFactValue(size);
        if (!clean || /^other$/i.test(clean)) return;
        if (sizes.indexOf(clean) === -1) sizes.push(clean);
      });
      splitPipe(card.getAttribute('data-tt-surface') || '').forEach(function (surface) {
        var clean = cleanFactValue(surface);
        if (!clean) return;
        if (/wall/i.test(clean)) wall = true;
        if (/floor/i.test(clean)) floor = true;
      });
    });
    sizes.sort(function (a, b) {
      return (parseInt(a, 10) || 0) - (parseInt(b, 10) || 0) || String(a).localeCompare(String(b));
    });
    var where = '—';
    if (wall && floor) where = 'Wall & floor';
    else if (wall) where = 'Wall only';
    else if (floor) where = 'Floor only';
    return {
      style: mostCommon(styles) || (item && item.param === 'style' ? item.value : '') || '—',
      count: cards.length ? String(cards.length) : '—',
      sizes: sizes.length ? sizes.map(function (size) {
        return String(size).replace(/\s*[x×]\s*/ig, ' × ');
      }).join(', ') : '—',
      surface: where
    };
  }

  function fillOverviewFacts(root, item) {
    var facts = root.querySelector('[data-tt-overview-facts]');
    if (!facts) return;
    var data = landingFacts(root, item);
    Object.keys(data).forEach(function (key) {
      var el = facts.querySelector('[data-tt-fact="' + key + '"]');
      if (el) el.textContent = data[key];
    });
  }

  function categoryFallbackImage(value) {
    var el = document.querySelector('[data-tt-category-fallbacks]');
    if (!el || !el.textContent) return '';
    try {
      var map = JSON.parse(el.textContent);
      return map && map[value] ? String(map[value]) : '';
    } catch (e) {
      return '';
    }
  }

  function renderCategoryHero(item) {
    var heading = item.heading || ((item.title || item.value || 'Tiles') + ' Tiles');
    var image = safeImageUrl(item.image) || (item.param !== 'family' ? safeImageUrl(categoryFallbackImage(item.value)) : '');
    var align = String(item.imageAlign || item.image_align || 'center').toLowerCase();
    if (align === 'centre' || align === 'middle') align = 'center';
    if (align !== 'top' && align !== 'bottom') align = 'center';
    var photo = image
      ? '<img class="tt-overview__photo" src="' + escapeHtml(image) + '" alt="' + escapeHtml(heading) + '" width="900" height="1200">'
      : '';
    return (
      '<header class="tt-overview" data-tt-category-hero data-tt-hero-param="' + escapeHtml(item.param) + '" data-tt-hero-value="' + escapeHtml(item.value) + '" data-tt-hero-align="' + escapeHtml(align) + '">' +
        '<div class="tt-overview__top">' +
          '<div class="tt-overview__media">' + photo + '</div>' +
          '<hr class="tt-overview__rule">' +
          '<div class="tt-overview__body">' +
            '<div class="tt-overview__rail tt-head tt-head--light" data-tt-head>' +
              '<div class="tt-head__rail">' +
                '<span class="tt-head__eyebrow">' + escapeHtml(landingEyebrow(item.param)) + '</span>' +
                '<span class="tt-head__rule" aria-hidden="true"></span>' +
              '</div>' +
            '</div>' +
            '<h1 class="tt-overview__title">' + accentHeading(heading) + '</h1>' +
            '<p class="tt-overview__lede">' + escapeHtml(item.description || 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.') + '</p>' +
            '<div class="tt-overview__facts" data-tt-overview-facts>' +
              overviewFact('Tiles', 'count') +
              overviewFact('Where', 'surface') +
            '</div>' +
            '<button type="button" class="tt-overview__scroll" data-tt-overview-scroll>' +
              '<span class="tt-overview__scroll-label">Scroll down to view the collection</span>' +
              '<span class="tt-overview__scroll-pill" aria-hidden="true">' +
                '<svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" focusable="false"><path d="M6 9l6 6 6-6"></path></svg>' +
              '</span>' +
            '</button>' +
          '</div>' +
        '</div>' +
        '<div class="tt-overview__foot tt-head tt-head--light" data-tt-head>' +
          '<div class="tt-head__rail">' +
            '<span class="tt-head__eyebrow">The tiles</span>' +
            '<span class="tt-head__rule" aria-hidden="true"></span>' +
            '<span class="tt-head__meta" data-tt-overview-count></span>' +
          '</div>' +
        '</div>' +
      '</header>'
    );
  }

  function collectionHeading(family) {
    var name = family.heading || family.title || family.rangeKey || '';
    name = String(name).replace(/\s+tiles\s*$/i, '').replace(/\s+collection\s*$/i, '').trim();
    return name ? name + ' Collection' : 'Collection';
  }

  function updateCategoryHero(root, groups) {
    var category = currentCategoryLanding(root, groups);
    var family = currentFamilyLanding(root);
    var landing = category || (family ? {
      param: 'family',
      value: family.rangeKey,
      heading: collectionHeading(family),
      description: family.description || '',
      image: family.image || '',
      imageAlign: family.imageAlign || family.image_align || 'center',
      products: family.products || []
    } : null);
    var host = root.querySelector('[data-tt-landing-host]');
    var show = !!landing && !isBrowseView(root);

    root.classList.toggle('tt-collection--landing', show);

    if (show && host) {
      host.hidden = false;
      host.innerHTML = renderCategoryHero(landing);
      fillOverviewFacts(root, landing);
      var countMeta = host.querySelector('[data-tt-overview-count]');
      var countFact = host.querySelector('[data-tt-fact="count"]');
      if (countMeta && countFact && /^\d+$/.test(countFact.textContent)) {
        var n = parseInt(countFact.textContent, 10);
        countMeta.textContent = (n < 10 ? '0' + n : n) + (n === 1 ? ' tile' : ' tiles');
      }
      var hero = host.querySelector('[data-tt-category-hero]');
      requestAnimationFrame(function () {
        if (hero) hero.classList.add('tt-patterns-settled');
      });
      var href = landing.param === 'family'
        ? browseAllHref('family', landing.value)
        : browseAllHref(landing.param, landing.value);
      syncLandingCtas(root, landingDisplayName(landing), href);
      refreshHeads();
      var scrollBtn = host.querySelector('[data-tt-overview-scroll]');
      if (scrollBtn) {
        scrollBtn.addEventListener('click', function () {
          var target = root.querySelector('[data-tt-product-grid]') || root.querySelector('.tt-collection__main');
          if (!target) return;
          var top = target.getBoundingClientRect().top + window.pageYOffset - 96;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        });
      }
    } else {
      if (host) {
        host.innerHTML = '';
        host.hidden = true;
      }
      syncLandingCtas(root, '', '');
    }

    var header = root.querySelector('.tt-collection__header');
    var headingEl = root.querySelector('[data-tt-page-heading]');
    if (header) header.classList.toggle('tt-collection__header--after-hero', show);
    if (headingEl) headingEl.hidden = show;
  }

  function updateHeading(root, groups) {
    var headingEl = root.querySelector('[data-tt-page-heading]');
    if (headingEl) {
      headingEl.textContent = getPageHeading(root, groups);
    }
    updateCategoryHero(root, groups);

    var seoIntro = root.querySelector('[data-tt-seo-intro]');
    var hero = root.querySelector('[data-tt-category-hero]');
    var heroVisible = !!(hero && !hero.hidden);
    var showSeo = shouldShowSeoIntro(groups) && !heroVisible;
    var seoHtml = showSeo ? getCategorySeoHtml(groups) : '';

    if (seoIntro) {
      if (showSeo) {
        seoIntro.hidden = false;
        if (seoHtml) {
          seoIntro.innerHTML = seoHtml;
        }
      } else {
        seoIntro.hidden = true;
        seoIntro.innerHTML = '';
      }
    }

    updateCollectionDesc(root, showSeo);
  }

  function updateCount(root, visible) {
    var countEl = root.querySelector('[data-tt-result-count]');
    if (!countEl) return;
    countEl.textContent = '[' + visible + ' Tiles]';
  }

  function updateClearButtons(root, hasActive) {
    root.querySelectorAll('[data-tt-clear-filters]').forEach(function (btn) {
      btn.hidden = !hasActive;
    });
  }

  function getSearchQuery(root) {
    var input = root.querySelector('[data-tt-collection-search]');
    return input ? input.value.trim().toLowerCase() : '';
  }

  var SEARCH_ALIASES = {
    japandi: { style: 'Scandinavian' },
    heritage: { style: 'Victorian' },
    vintage: { style: 'Victorian' },
    plank: { shape: 'Metro' },
    subway: { shape: 'Metro' }
  };

  function productMatchesSearch(card, query) {
    if (!query) return true;
    var needle = query.toLowerCase();
    var titleEl = card.querySelector('.tt-tile-card__title');
    var title = titleEl ? titleEl.textContent.toLowerCase() : '';
    var haystack = [
      title,
      card.getAttribute('data-tt-style') || '',
      card.getAttribute('data-tt-shape') || '',
      card.getAttribute('data-tt-search') || ''
    ].join(' ').toLowerCase();
    if (haystack.indexOf(needle) !== -1) return true;

    var alias = SEARCH_ALIASES[needle];
    if (!alias) return false;
    var tax = cardTaxonomy(card);
    if (alias.style && tax.style.indexOf(alias.style) !== -1) return true;
    if (alias.shape && tax.shape === alias.shape) return true;
    return false;
  }

  function applyFilters(root) {
    var groups = getCheckedFilters(root);
    var requested = requestedFilters(root);
    Object.keys(requested).forEach(function (key) {
      requested[key].forEach(function (value) {
        if (!groups[key]) groups[key] = [];
        if (groups[key].indexOf(value) === -1) groups[key].push(value);
      });
    });
    var query = getSearchQuery(root);
    var familyKey = (root.getAttribute('data-tt-family') || '').toLowerCase();
    if (!familyKey && window.URLSearchParams) {
      familyKey = (new URLSearchParams(window.location.search).get('family') || '').toLowerCase();
    }
    var cards = root.querySelectorAll('[data-tt-product]');
    var empty = root.querySelector('[data-tt-empty]');
    var visible = 0;
    var hasActive = Object.keys(groups).some(function (k) { return groups[k].length; }) || query.length > 0;

    cards.forEach(function (card) {
      var familyOk = !familyKey || (card.getAttribute('data-tt-range') || '').toLowerCase() === familyKey;
      var show = familyOk && productMatches(card, groups) && productMatchesSearch(card, query);
      card.hidden = !show;
      if (show) visible += 1;
    });

    var landing = currentCategoryLanding(root, groups) || currentFamilyLanding(root);
    if (landing && !isBrowseView(root) && landing.products && landing.products.length) {
      var allow = {};
      landing.products.forEach(function (handle) {
        allow[String(handle || '').toLowerCase()] = true;
      });
      visible = 0;
      cards.forEach(function (card) {
        var handle = (card.getAttribute('data-tt-product-handle') || '').toLowerCase();
        if (!allow[handle]) card.hidden = true;
        if (!card.hidden) visible += 1;
      });
    }

    if (empty) empty.hidden = visible > 0;
    updateHeading(root, groups);
    updateCount(root, visible);
    updateClearButtons(root, hasActive);
    syncUrlFromFilters(root, groups);
  }

  function clearFilters(root) {
    root.querySelectorAll('[data-tt-filter]').forEach(function (input) {
      input.checked = false;
    });
    var searchInput = root.querySelector('[data-tt-collection-search]');
    if (searchInput) searchInput.value = '';
    var landingParam = root.getAttribute('data-tt-landing-param');
    var landingValue = root.getAttribute('data-tt-landing-value');
    if (landingParam && landingValue) setFilterChecks(root, landingParam, landingValue);
    applyFilters(root);
  }

  function collectPresentFilterValues(root) {
    var present = {};
    function add(key, value) {
      if (!value) return;
      if (!present[key]) present[key] = {};
      present[key][value] = true;
    }

    root.querySelectorAll('[data-tt-product]').forEach(function (card) {
      var tax = cardTaxonomy(card);
      (tax.technique || []).forEach(function (value) { add('technique', value); });
      (tax.motif || []).forEach(function (value) { add('motif', value); });
      (tax.style || []).forEach(function (value) { add('style', value); });
      add('shape', tax.shape);
      add('finish', tax.finish);
      splitPipe(card.getAttribute('data-tt-colour') || '').forEach(function (value) { add('colour', value); });
      splitPipe(card.getAttribute('data-tt-rooms') || '').forEach(function (value) { add('room', value); });
      splitPipe(card.getAttribute('data-tt-size') || '').forEach(function (value) { add('size', value); });
      splitPipe(card.getAttribute('data-tt-surface') || '').forEach(function (value) { add('surface', value); });
      splitPipe(card.getAttribute('data-tt-badges') || '').forEach(function (value) { add('badge', value); });
      if (card.getAttribute('data-tt-on-sale') === 'true') add('badge', 'On Sale');
      if (card.getAttribute('data-tt-out-of-stock') === 'true') add('badge', 'Out of Stock');
    });

    return present;
  }

  function syncEmptyFilterOptions(root) {
    var present = collectPresentFilterValues(root);
    var requested = requestedFilters(root);
    root.querySelectorAll('[data-tt-filter]').forEach(function (input) {
      var key = input.getAttribute('data-tt-filter');
      var value = canonicalizeFilterValue(key, input.value);
      var keepRequested = isRequestedFilter(requested, key, value);
      var hasTiles = !!(present[key] && present[key][value]);
      var label = input.closest('.tt-filter-check');
      input.disabled = !hasTiles && !keepRequested;
      if (!hasTiles && !keepRequested) {
        input.checked = false;
        if (label) {
          label.classList.add('tt-filter-check--empty');
          label.setAttribute('aria-disabled', 'true');
        }
        return;
      }
      if (label) {
        label.classList.remove('tt-filter-check--empty');
        label.removeAttribute('aria-disabled');
      }
    });
  }

  function initMobilePanel(root) {
    var toggle = root.querySelector('[data-tt-filter-toggle]');
    var panel = root.querySelector('[data-tt-filters-panel]');
    if (!toggle || !panel) return;

    function setFilterPanelOpen(toggle, panel, open) {
      if (open) {
        panel.removeAttribute('hidden');
        toggle.setAttribute('aria-expanded', 'true');
        toggle.setAttribute('aria-checked', 'true');
      } else {
        panel.setAttribute('hidden', '');
        toggle.setAttribute('aria-expanded', 'false');
        toggle.setAttribute('aria-checked', 'false');
      }
    }

    toggle.addEventListener('click', function () {
      var open = panel.hasAttribute('hidden');
      setFilterPanelOpen(toggle, panel, open);
    });

    if (window.matchMedia('(min-width: 1100px)').matches) {
      setFilterPanelOpen(toggle, panel, true);
    }
  }

  function refreshCollectionFromUrl(root) {
    syncFiltersFromUrl(root);
    syncFiltersFromServerState(root);
    syncEmptyFilterOptions(root);
    applyFilters(root);
  }

  function init(root) {
    if (!root || root.dataset.ttCollectionInit) return;
    root.dataset.ttCollectionInit = 'true';

    root.addEventListener('change', function (event) {
      if (event.target.matches('[data-tt-filter]')) {
        applyFilters(root);
      }
    });

    root.querySelectorAll('[data-tt-clear-filters]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        clearFilters(root);
      });
    });

    var searchInput = root.querySelector('[data-tt-collection-search]');
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        applyFilters(root);
      });
      if (searchInput.form) {
        searchInput.form.addEventListener('submit', function (event) {
          event.preventDefault();
          applyFilters(root);
        });
      }
    }

    initMobilePanel(root);
    refreshCollectionFromUrl(root);
  }

  function handleCollectionPageShow(event) {
    document.querySelectorAll('[data-tt-collection]').forEach(function (root) {
      if (!root.dataset.ttCollectionInit) return;
      if (event.persisted) {
        var searchInput = root.querySelector('[data-tt-collection-search]');
        if (searchInput) searchInput.value = '';
        refreshCollectionFromUrl(root);
      }
    });
  }

  function settleLandingHeroes() {
    var heroes = document.querySelectorAll('[data-tt-category-hero], [data-tt-family-hero]');
    if (!heroes.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var settle = function () {
      heroes.forEach(function (hero) {
        hero.classList.add('tt-patterns-settled');
      });
    };
    if (reduce) {
      settle();
      return;
    }
    requestAnimationFrame(function () {
      requestAnimationFrame(settle);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-tt-collection]').forEach(init);
    settleLandingHeroes();
  });

  window.addEventListener('pageshow', handleCollectionPageShow);
})();
